import { render, staticRenderFns } from "./home-footer.vue?vue&type=template&id=013b3db3&lang=pug&"
import script from "./home-footer.vue?vue&type=script&lang=js&"
export * from "./home-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports